export default "__VITE_ASSET__DhIxbFt1__"